export default "__VITE_ASSET__CfEyJy$K__"